export default __webpack_public_path__ + "static/media/mint.48f46fe2.PNG";